// @ts-strict-ignore
import MDEditor, { MDEditorProps } from '@uiw/react-md-editor';
import * as React from 'react';
import rehypeSanitize from 'rehype-sanitize';

function decodeHTML(str: string) {
    if (!str) {
        return '';
    }

    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(str, 'text/html');
    const documentElement = parsedDoc.documentElement;
    const textContent = documentElement.textContent;
    const decodedText = textContent ?? '';
    return decodedText;
}

const MarkdownEditor: React.FC<MDEditorProps> = (props: MDEditorProps) => {
    return <MDEditor {...props} value={decodeHTML(props.value)} previewOptions={{ rehypePlugins: [rehypeSanitize] }} />;
};

export default MarkdownEditor;
